import React from 'react';
import VotingList from '../components/VotingList';
import ProtectedRoute from '../components/ProtectedRoute';
import { useVotingOptions } from '../context/VotingOptionsContext';

const VoteFb = () => {
  const { options, isLoading, error } = useVotingOptions();

  return (
    <ProtectedRoute>
      <div className="voting-page-container">
        <div className="container">
          <VotingList
            title="請投選10個最熱門社交媒體專頁"
            subtitle="（投票前，可點擊‘Facebook’或‘Instagram’瀏覽其社交平台了解更多）"
            nextUrl="/voting/ott"
            items={options.fb}
            maxSelections={10}
            storageKey="fb"
            showBackButton={true}
            backUrl="/voting/site"
            forceLoading={isLoading}
            forceError={error}
          />
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default VoteFb;
